module.exports = __webpack_public_path__ + "static/9-5a362c5676ac5744324dd389c8453db1.jpg";